module.exports = __webpack_public_path__ + "static/media/seal.95a4b3f2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/common/img/seals/CA/seal.svg
// module id = 1080
// module chunks = 0